import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CanNotActivateDirective } from "./can-activate.directive";
import { FocusDirective } from "./focus.directive";
import { RDatePipe } from "../pipes/rdate.pipe";
import { NgSelectSortDirective } from "./ng-select-sort.directive";

@NgModule({
  declarations: [
    CanNotActivateDirective,
    FocusDirective,
    RDatePipe,
    NgSelectSortDirective,
  ],
  imports: [CommonModule],
  exports: [
    CanNotActivateDirective,
    FocusDirective,
    RDatePipe,
    NgSelectSortDirective,
  ],
})
export class DirectivesModule {}
